/** Relative time for deal analytics (e.g. "2h ago"). */
export function relativeTime(iso: string | number | Date): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "n/a";
  const sec = Math.round((Date.now() - t) / 1000);
  if (sec < 45) return "just now";
  if (sec < 3600) return `${Math.max(1, Math.round(sec / 60))}m ago`;
  if (sec < 86400) return `${Math.round(sec / 3600)}h ago`;
  if (sec < 86400 * 7) return `${Math.round(sec / 86400)}d ago`;
  return new Date(t).toLocaleDateString();
}

export function recipientStatusLabel(status: string): string {
  const s = status.toLowerCase();
  if (s === "invited" || s === "pending") return "Invited";
  if (s === "active" || s === "opened" || s === "viewed") return "Opened";
  if (s === "revoked") return "Revoked";
  return status;
}

export function recipientStatusTone(status: string): "ok" | "warn" | "new" | "" {
  const s = status.toLowerCase();
  if (s === "active" || s === "opened" || s === "viewed") return "ok";
  if (s === "invited" || s === "pending") return "warn";
  if (s === "revoked") return "new";
  return "";
}
